import { composeUseFlow } from "@deliverr/ui-facility/lib-facility/flow/composeUseFlow";
import { scanFlowButtonsState, scanFlowCardsState, ScanButtonType } from "./scanFlowState";

export const useScanFlow = composeUseFlow<ScanButtonType>({
  cardsState: scanFlowCardsState,
  buttonsState: scanFlowButtonsState,
});
